import React from 'react';
import { AppStrings } from '../i18n/localizations';

interface LangContextType {
  lang: string;
  currentLangData: AppStrings;
}

export const LangContext = React.createContext<LangContextType>({
  lang: '',
  currentLangData: {} as AppStrings,
});
